import { defineComponent as _defineComponent } from 'vue'
import { onMounted, ref } from 'vue';
import sharedMessages from '@/lib/shared-messages';
import { defineMessages } from '@/lib/i18n';
import { dispatchDeleteCompanyWhitelistIp } from '@/store/main/actionsMain';
import { readAssertedCompanyId } from '@/store/main/getters';
import store from '@/store';
import { CompanyWhiteListIpGetResponse } from '@/interfaces/api/general/company';
import { dispatchGetClientIp } from '@/store/main/actionsMain';
import { commitAddNotification } from '@/store/main/mutations';

export default /*#__PURE__*/_defineComponent({
  __name: 'DeleteIpAddress',
  props: {
    targetIpAddress: null,
    ipAddressList: null
  },
  emits: ["reset:targetIpAddress"],
  setup(__props: any, { emit: emits }: { emit: ({
  (e: 'reset:targetIpAddress', withRefresh?: boolean): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  targetIpAddress?: string;
  ipAddressList: CompanyWhiteListIpGetResponse['data'];
};

const clientIpList = ref<string[]>([]);





const m = defineMessages({
  confirmDeleteIpAddress: 'IPアドレスを削除しますか？',
  ipAddressToDelete: '削除するIPアドレスは {targetIpAddress} です',
});

const isAnySelfIp = (
  clientIpList: string[],
  targetDeleteIp: string
): boolean => {
  // 現在経由している複数のIPアドレスのうち、いずれかが削除対象に該当するかチェック
  return clientIpList.some((clientIp) => isSelfIp(clientIp, targetDeleteIp));
};

const isSelfIp = (clientIp: string, targetDeleteIp: string): boolean => {
  if (!targetDeleteIp.trim().includes('/')) {
    if (clientIp.trim() === targetDeleteIp.trim()) return true;

    return false;
  } else {
    const clientIpParse = parseClientIp(clientIp);
    const [prefix, subnetMask, maskedTargetDeletIp] =
      parseCidrIp(targetDeleteIp);

    return checkIpInCidr(
      clientIpParse,
      prefix,
      subnetMask,
      maskedTargetDeletIp
    );
  }
};
const parseClientIp = (clientIp: string): number => {
  const clientIpParts = clientIp.trim().split('.');
  let clientIpParse = 0;

  for (const clientIpPart of clientIpParts) {
    const clientIpPartToNumber = Number(clientIpPart);
    clientIpParse = (clientIpParse << 8) | clientIpPartToNumber;
  }
  clientIpParse >>>= 0;

  return clientIpParse;
};

const parseCidrIp = (targetDeleteIp: string): [number, number, number] => {
  const [ipStr, prefixStr] = targetDeleteIp
    .split('/', 2)
    .map((s) => s.trim()) as [string, string];
  const prefix = Number(prefixStr);
  const ipParts = ipStr.split('.');
  let ip = 0;

  for (const ipPart of ipParts) {
    const ipPartToNumber = Number(ipPart);
    ip = (ip << 8) | ipPartToNumber;
  }
  ip >>>= 0;

  const subnetMask = prefix === 0 ? 0 : (0xffffffff << (32 - prefix)) >>> 0;
  const maskedIp = (ip & subnetMask) >>> 0;

  return [prefix, subnetMask, maskedIp];
};

const checkIpInCidr = (
  clientIpParse: number,
  prefix: number,
  subnetMask: number,
  maskedTargetDeletIp: number
): boolean => {
  const maskedClientIp = (clientIpParse & subnetMask) >>> 0;

  if (maskedClientIp !== maskedTargetDeletIp) return false;
  if (prefix >= 31) return true;

  const broadcastAddress = (maskedTargetDeletIp | (~subnetMask >>> 0)) >>> 0;

  return (
    clientIpParse !== maskedTargetDeletIp && clientIpParse !== broadcastAddress
  );
};

const deleteCompanyWhitelistIp = async () => {
  const ipAddress = props.targetIpAddress as string;

  if (
    isAnySelfIp(clientIpList.value, ipAddress) &&
    props.ipAddressList.length > 1
  ) {
    commitAddNotification(store, {
      messageKey: sharedMessages.deleteClientIpAlert,
      color: 'error',
    });
    return;
  }

  try {
    await dispatchDeleteCompanyWhitelistIp(store, {
      companyId: readAssertedCompanyId(store),
      ipAddress,
    });
  } finally {
    emits('reset:targetIpAddress', true);
  }
};

const getClientIp = async (): Promise<void> => {
  const response = await dispatchGetClientIp(store);
  if (!response) {
    return;
  }
  // APIは現在、ip_addressesという配列を返します
  clientIpList.value = response.data['ip_addresses'] || [];
};

onMounted(async () => {
  await getClientIp();
});

return { __sfc: true,clientIpList, props, emits, m, isAnySelfIp, isSelfIp, parseClientIp, parseCidrIp, checkIpInCidr, deleteCompanyWhitelistIp, getClientIp, sharedMessages }
}

})